import { apiPath } from '../../constants';
import { axios, apiRequestOptions, errorRequestHandler, transformHttpResponse } from 'utils';
import { SCHEDULE_FETCH_SUCCESS } from './getScheduleAction';

/*
 * THE SCHEDULE'S COLOURS (organiser, 31 Oct 2026: «щоб адмін, чи головний
 * секретар, міг змінювати кольори карт, для різних категорій для розкладу»).
 * Both resolve `{types: [{type, default, color}], ageTone}`, or null on
 * failure (the error already shown).
 */

const failed = dispatch => error => {
    dispatch(errorRequestHandler(error));

    return null;
};

export const fetchScheduleColors = competitionId => dispatch =>
    axios(apiRequestOptions(apiPath.SCHEDULE.COLORS_GET, null, { params: { id: competitionId } }))
        .then(transformHttpResponse)
        .then(response => response.data)
        .catch(error => transformHttpResponse(error.response))
        .catch(failed(dispatch));

/**
 * `{categoryColors: {type: '#rrggbb' | null}, ageTone}` — then the board is
 * read again QUIETLY (success only): the colours change under the user's
 * eyes, with no spinner over the board for each pick.
 */
export const saveScheduleColors = (competitionId, data) => dispatch =>
    axios(apiRequestOptions(apiPath.SCHEDULE.COLORS_PUT, data, { params: { id: competitionId } }))
        .then(transformHttpResponse)
        .then(response => {
            axios(apiRequestOptions(apiPath.SCHEDULE.GET, null, { params: { id: competitionId } }))
                .then(transformHttpResponse)
                .then(board => dispatch({ type: SCHEDULE_FETCH_SUCCESS, data: board.data }))
                .catch(() => null);

            return response.data;
        })
        .catch(error => transformHttpResponse(error.response))
        .catch(failed(dispatch));
